import { Routes } from '@angular/router';

export const openSpinnersRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./open-spinners.page').then((m) => m.OpenSpinnersPage),
  },
];
